////////////////////////////////////////////////////////////////////////////////
//                                                                            //
//  IRONSIDE - Public Website GUI                                             //
//                                                                            //
//  Version: 1.0.3                                                            //
//  Summary: Liquid-glass content surface (1.0.3.md §5)                     //
//                                                                            //
////////////////////////////////////////////////////////////////////////////////
//
//  Per §5: "ALL content sections live in glass tiles — the hero/page titles are
//  the only free-floating text." GlassTile is deliberately just the visual
//  finish, content-sized (it has no opinion on width/max-width/placement) — the
//  caller keeps its own semantic landmark (`<section aria-labelledby=...>`,
//  matching the existing convention in pages/public/*.tsx) and renders GlassTile
//  as that section's visual child:
//
//    <section aria-labelledby="x-heading">
//      <GlassTile>
//        <h2 id="x-heading">...</h2>
//        ...
//      </GlassTile>
//    </section>
//
//  The actual blur/border/fallback treatment lives in styles/glass.css's
//  `.glass-tile` (kept out of Tailwind utilities so the `@supports` and
//  `prefers-reduced-transparency`/`prefers-reduced-motion` degrades have one
//  home instead of being re-declared per usage). See that file's cap-guidance
//  comment before stacking many GlassTiles in one dense grid.
//
////////////////////////////////////////////////////////////////////////////////

import type { HTMLAttributes, ReactNode } from 'react';

export interface GlassTileProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function GlassTile ({ children, className, ...rest }: GlassTileProps) {
  const classes = className ? `glass-tile ${className}` : 'glass-tile';
  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}
